<app-add-settlements-template
  [dialogRef]="dialogRef"
>
</app-add-settlements-template>
